import React, { Fragment } from "react";
import { checkPermission } from "../helpers/utilities";

interface Props {
  entitlement: string | undefined;
  defaultView?: JSX.Element;
}

interface State {
  canAccess: boolean;
}

export default class EntitledSection extends React.Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);
    const stringifiedUser = localStorage.getItem("user");
    const user = JSON.parse(stringifiedUser as string);
    this.state = {
      canAccess: checkPermission(user, this.props.entitlement).canAccess,
    };
  }

  render(): JSX.Element | null {
    const { canAccess } = this.state;
    const { children, defaultView } = this.props;
    const view: JSX.Element | null = defaultView || null;

    return canAccess ? (
      <Fragment>{children}</Fragment>
    ) : (
      <Fragment>{view}</Fragment>
    );
  }
}
